import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import API from '../api/api';
import "./CategoryPage.css";

const CategoryPage = () => {
  const { category } = useParams();
  const [subcategories, setSubcategories] = useState([]);
  const [videoUrl, setVideoUrl] = useState(null);

  // Convert YouTube link → embed URL
  const getEmbedUrl = (url) => {
  try {
    const parsed = new URL(url);

    // 1. Normal YouTube videos
    if (parsed.hostname.includes("youtube.com") && parsed.pathname === "/watch") {
      const videoId = parsed.searchParams.get("v");
      return `https://www.youtube.com/embed/${videoId}?autoplay=1`;
    }

    // 2. YouTube Shorts
    if (parsed.pathname.startsWith("/shorts/")) {
      const videoId = parsed.pathname.split("/shorts/")[1].split("?")[0];
      return `https://www.youtube.com/embed/${videoId}?autoplay=1`;
    }

    // 3. youtu.be short links
    if (parsed.hostname === "youtu.be") {
      const videoId = parsed.pathname.replace("/", "");
      return `https://www.youtube.com/embed/${videoId}?autoplay=1`;
    }

    return "";
  } catch (error) {
    console.error("Invalid YouTube URL:", url);
    return "";
  }
};


  const loadCategoryData = async () => {
    try {
      const res = await API.get("/schemes");
      const allSchemes = res.data;

      for (const scheme of allSchemes) {
        // Scheme must be visible in schemes list
        if (!scheme.showInSchemeList) continue;

        const matchedCategory = scheme.categories.find(
          (c) => c.name === category && c.showInSchemeList === true
        );

        if (matchedCategory) {
          // filter only visible subcategories
          const visibleSubs = (matchedCategory.subcategories || []).filter(
            (sub) => sub.showInSchemeList === true
          );

          setSubcategories(visibleSubs);
          return;
        }
      }

      // If nothing found
      setSubcategories([]);

    } catch (err) {
      console.error("Error fetching category data:", err);
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    loadCategoryData();
  }, [category]);

  return (
    <div className="category-page-wrapper">
      <div className="category-page-card shadow-lg">
        <h3 className="category-title">{category}</h3>
        <div className="underline"></div>

        {subcategories.length === 0 ? (
          <p className="no-data">No services found in this category.</p>
        ) : (
          <div className="row mt-4">
            {subcategories.map((sub, index) => (
              <div key={index} className="col-lg-4 col-md-4 col-sm-6 mb-4">
                <div className="subcategory-card shadow-sm">
                  <h5 className="name">{sub.name}</h5>

                  <div className="btn-row mt-3">
                    {sub.applyLink && (
                      <a
                        href={sub.applyLink}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="btn apply-btn"
                      >
                        Apply Online
                      </a>
                    )}

                    {sub.youtubeLink && (
                      <button
                        className="btn video-btn"
                        onClick={() => setVideoUrl(getEmbedUrl(sub.youtubeLink))}
                      >
                        Watch Video
                      </button>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>

      {/* VIDEO POPUP MODAL */}
      {videoUrl && (
        <div className="video-modal-overlay" onClick={() => setVideoUrl(null)}>
          <div className="video-modal" onClick={(e) => e.stopPropagation()}>
            <iframe
              width="100%"
              height="350"
              src={videoUrl}
              title="YouTube Video"
              frameBorder="0"
              allow="autoplay; encrypted-media"
              allowFullScreen
            ></iframe>

            <button className="close-btn" onClick={() => setVideoUrl(null)}>X</button>
          </div>
        </div>
      )}
    </div>
  );
};

export default CategoryPage;
